/* Precaricamento in background dei link interni.
   Quando l'utente passa il mouse (o il dito, su touch) sopra un link della
   pagina, iniziamo a scaricare quella pagina in background, PRIMA che
   l'utente clicchi davvero. Se poi clicca, la pagina e' gia' in cache e si
   apre quasi subito, senza il caricamento lungo.
   Non cambia nulla nell'aspetto o nel funzionamento del sito: e' solo un
   suggerimento al browser (rel=prefetch), che il browser stesso ignora se
   la connessione dell'utente e' lenta o a consumo (Data Saver). */
(function () {
  var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection;
  if (conn && (conn.saveData || /^(slow-2g|2g)$/.test(conn.effectiveType || ''))) return;

  var done = {};
  var count = 0;
  var MAX_PREFETCH = 30;

  function skip(url) {
    if (!url) return true;
    if (url.indexOf('/cart') !== -1) return true;
    if (url.indexOf('/checkout') !== -1) return true;
    if (url.indexOf('/account') !== -1) return true;
    if (url.indexOf('#') !== -1) return true;
    return false;
  }

  function maybePrefetch(anchor) {
    if (!anchor || !anchor.href) return;
    if (count >= MAX_PREFETCH) return;
    var url = anchor.href;
    if (done[url]) return;
    if (anchor.origin !== window.location.origin) return;
    if (skip(anchor.pathname + anchor.search)) return;

    done[url] = true;
    count += 1;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function onHoverIntent(e) {
    var anchor = e.target.closest && e.target.closest('a[href]');
    if (anchor) maybePrefetch(anchor);
  }

  document.addEventListener('mouseover', onHoverIntent, { passive: true });
  document.addEventListener('touchstart', onHoverIntent, { passive: true });
  document.addEventListener('focusin', onHoverIntent, { passive: true });
}());
